import IconChevronUp from 'assets/icons/chevron-up-stroke.svg';
import cn from 'classnames';
import LazyMotionWrapper from 'components/lazy-motion-wrapper';
import Price from 'components/price';
import { useCartState } from 'modules/cart/state';
import { Gtm } from 'tracking';
import { m } from 'motion/react';
import React from 'react';
import { FormattedMessage } from 'react-intl';

interface Props {
  setCartExpanded: (expanded: boolean) => void;
  isCartExpanded: boolean;
  showSubTotal?: boolean;
  hasExistingSub?: boolean;
}

const FunnelCart: React.FC<Props> = ({
  setCartExpanded,
  isCartExpanded,
  showSubTotal = false,
  hasExistingSub = false,
}) => {
  const { effectiveCart } = useCartState();

  const cartExpandText = React.useMemo(() => {
    if (hasExistingSub) {
      return isCartExpanded ? 'subscription-funnel:cart-hide' : 'subscription-funnel:cart-show';
    }
    return isCartExpanded
      ? 'subscription-funnel:existing-subscription:cart-hide'
      : 'subscription-funnel:existing-subscription:cart-show';
  }, [isCartExpanded, hasExistingSub]);

  return (
    <LazyMotionWrapper>
      <div
        className={cn(
          'bg-other-white text-primary-main w-full lg:hidden',
          !isCartExpanded && 'shadow-xs'
        )}
      >
        <div className="container flex h-12 items-center justify-between">
          <m.button
            className="flex items-center leading-0 font-black focus:outline-hidden"
            onClick={() => {
              if (!isCartExpanded) {
                Gtm.track({
                  group: Gtm.Group.Component,
                  name: Gtm.ComponentEvent.Click,
                  data: { label: `Checkout-Overview` },
                });
              }
              setCartExpanded(!isCartExpanded);
            }}
          >
            <FormattedMessage id={cartExpandText} />
            <m.div
              initial={{ rotate: 180 }}
              animate={{ rotate: isCartExpanded ? 0 : 180 }}
              transition={{
                duration: 0.8,
                ease: [0.04, 0.62, 0.23, 0.98],
              }}
            >
              <IconChevronUp className="ml-1 h-6 w-6" />
            </m.div>
          </m.button>

          {!isCartExpanded && (
            <div className="font-medium">
              {effectiveCart && (
                <Price
                  cents
                  value={showSubTotal ? effectiveCart.itemsTotal : effectiveCart.cartTotal}
                />
              )}
            </div>
          )}
        </div>
      </div>
    </LazyMotionWrapper>
  );
};

export default FunnelCart;
